/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import style from "../styles/privacy.module.scss";
import { GlobalContext } from "../context/GlobalContext";
import ReactMarkdown from "react-markdown";
import Loader from "../components/shared/Loader";
import withHelmet from "../seo/withHelmet";
import { termsHelmetProps } from "../seo/helmetProps";

const Terms = () => {
  const { loading, getTerm, term } = useContext(GlobalContext);

  useEffect(() => {
    getTerm();
  }, []);
  return (
    <>
      {loading || term === undefined ? (
        <Loader />
      ) : (
        <div className={style.wrapper}>
          <ReactMarkdown>{term}</ReactMarkdown>
        </div>
      )}
    </>
  );
};

export default withHelmet(Terms, termsHelmetProps);
